module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("\n    " + _vm._s(_vm.resultsLength) + " results found for \""), _c('b', [_vm._v(_vm._s(_vm.searchMessage))]), _vm._v("\"\n  ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-striped bank-accounts table-fundings"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("First name")]), _vm._v(" "), _c('th', [_vm._v("Last name")]), _vm._v(" "), (_vm.showCompanyNames) ? _c('th', [_vm._v("Company name 1")]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('th', [_vm._v("Company name 2")]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('th', [_vm._v("Account name")]) : _vm._e(), _vm._v(" "), _c('th', [_vm._v("Email")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.investors), function(investor) {
    return [_vm._l((investor.accounts), function(account, index) {
      return _c('tr', {
        key: (index + "-account-" + (account.accountId))
      }, [_c('td', [_vm._v(_vm._s(investor.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.lastName))]), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.organizationName || '---'))]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.alternateCompanyName || '---'))]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.accountName))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.email))]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-details btn-outline",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.goToViewDetail(investor.id, investor.userType, investor.firstName)
          }
        }
      }, [_vm._v("View details")])])])
    }), _vm._v(" "), (!investor.accounts || investor.accounts.length === 0) ? _c('tr', {
      key: investor.id
    }, [_c('td', [_vm._v(_vm._s(investor.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.lastName))]), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('td', [_vm._v("---")]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(investor.email))]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-details btn-outline",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          _vm.goToViewDetail(investor.id, investor.userType, investor.firstName)
        }
      }
    }, [_vm._v("View details")])])]) : _vm._e()]
  }), _vm._v(" "), _vm._l((_vm.accounts), function(account) {
    return _vm._l((account.users), function(user, index) {
      return _c('tr', {
        key: (index + "-user-" + (user.userId))
      }, [_c('td', [_vm._v(_vm._s(user.firstName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastName))]), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.organizationName || '---'))]) : _vm._e(), _vm._v(" "), (_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.alternateCompanyName || '---'))]) : _vm._e(), _vm._v(" "), (!_vm.showCompanyNames) ? _c('td', [_vm._v(_vm._s(account.accountName))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.email))]), _vm._v(" "), _c('td', [_c('button', {
        staticClass: "btn btn-details btn-outline",
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            _vm.goToViewDetail(user.id, user.userType, user.firstName)
          }
        }
      }, [_vm._v("View details")])])])
    })
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0e375d09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchByNameOrEmailResults.vue
// module id = 2103
// module chunks = 1